import React, { PureComponent } from 'react';
import { Modal, message } from 'antd';
import TableC from '../../basicElement/TableC';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import format from '../../shared/format';
import genOperationAuth from '../../common/genOperationAuth';
import { Default, MedicineType, RequestStatus, ContractNature } from './constants';

function adaptData(data) {
    (data || []).forEach(item => {
        item.startTime = format('date', item.startTime);
        item.endTime = format('date', item.endTime);
        item.jdeApplyTime = format('date', item.jdeApplyTime);
        item.investigationSponsorName = item.investigationSponsor;
    });
    return data;
}

class History extends PureComponent {
    state = {
        loading: false,
        data: [],
        pagination: {
            current: 1,
            pageSize: 10
        },
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.reload !== this.props.reload) {
            const { pagination } = this.state;
            this.setState({ pagination: {
                ...pagination,
                // current: 1
            }}, () => {
                this.loadData();
            });
        }
    }

    search = () => {
        const { pagination } = this.state;
            this.setState({ pagination: {
                ...pagination,
                current: 1,
            }}, () => {
                this.loadData();
            });
    }

    loadData = () => {
        const { searchParams } = this.props;
        const { pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            url: API_URL.investigation.queryAllInvJdeContractHistory,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: adaptData(datas),
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    delete = (record) => {
        Modal.confirm({
            iconType: 'question-circle',
            title: "确定要删除吗？",
            onOk: () => {
                $.sendRequest({
                    method: 'POST',
                    url: API_URL.investigation.deleteInvJdeContractHistory,
                    data: { investigationJdeContractHistoryId: record. investigationJdeContractHistoryId },
                    dataType: 'json',
                    doneResult: res => {
                        message.success(res.success);
                        this.loadData();
                    }
                });
            },
        });
    }

    getColumns = () => {
        const { curRole } = sessionStorage;

        const columns = [{
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            fixed: 'left',
            width: 100,
        }, {
            title: '合同编号',
            dataIndex: 'investigationJdeContractNumber',
            key: 'investigationJdeContractNumber',
            width: 100,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'mainInvestigationJdeContractCode',
            key: 'mainInvestigationJdeContractCode',
            width: 120,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineNames',
            key: 'secondLineNames',
            width: 100,
        }, {
            title: '类别码13',
            dataIndex: 'categoryCodeName13',
            key: 'categoryCodeName13',
            width: 80,
        }, {
            title: '合同签署单位',
            dataIndex: 'signingUnitName',
            key: 'signingUnitName',
            width: 100,
        }, {
            title: '收入归属单位',
            dataIndex: 'belongingToUnitName',
            key: 'belongingToUnitName',
            width: 100,
        }, {
            title: '名称(ProjectID)',
            dataIndex: 'projectIdName',
            key: 'projectIdName',
            width: 100,
        }, {
            title: '计收入确认方式',
            dataIndex: 'contractTypeValue',
            key: 'contractTypeValue',
            width: 80,
        }, {
            title: '发票税率',
            dataIndex: 'invoiceRate',
            key: 'invoiceRate',
            width: 80,
            render: text => format('unit', text, '%'),
        }, {
            title: '合同是否签署完成',
            dataIndex: 'investigationJdeContractIsSigned',
            key: 'investigationJdeContractIsSigned',
            width: 80,
            render: text => Default[text],
        }, {
            title: '合同性质',
            dataIndex: 'contractNature',
            key: 'contractNature',
            width: 80,
            render: text => ContractNature[text],
        }, {
            title: 'JDE发号时间',
            dataIndex: 'jdeApplyTime',
            key: 'jdeApplyTime',
            width: 100,
        }, {
            title: 'PM工号',
            dataIndex: 'pmEmployeeCode',
            key: 'pmEmployeeCode',
            width: 100,
        }, {
            title: 'PM姓名',
            dataIndex: 'pmUserCompellation',
            key: 'pmUserCompellation',
            width: 100,
        }, {
            title: 'BD工号',
            dataIndex: 'bdEmployeeCode',
            key: 'bdEmployeeCode',
            width: 100,
        }, {
            title: 'BD姓名',
            dataIndex: 'bdUserCompellation',
            key: 'bdUserCompellation',
            width: 100,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
            render: (text,record) =>{return <span style ={ record.dataSource  == 'IMPORT' ? { color:'red'}  : {}}>{text}</span>},
        }, {
            title: '项目阶段',
            dataIndex: 'investigationStageNames',
            key: 'investigationStageNames',
            width: 100,
        }, {
            title: '项目关闭申请情况',
            dataIndex: 'investigationRemittanceCompletedInfo',
            key: 'investigationRemittanceCompletedInfo',
            width: 120,
            render: text => RequestStatus[text],
        }, {
            title: '研究产品类型',
            dataIndex: 'investigationMedicineType',
            key: 'investigationMedicineType',
            width: 100,
            render: text => MedicineType[text],
        }, {
            title: '项目分期',
            dataIndex: 'investigationByStageNames',
            key: 'investigationByStageNames',
            width: 120,
        }, {
            title: '受试者类型',
            dataIndex: 'testeeTypeName',
            key: 'testeeTypeName',
            width: 100,
        }, {
            title: '项目分类',
            dataIndex: 'investigationType',
            key: 'investigationType',
            width: 120,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 120,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 100,
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            width: 100,
        }, {
            title: '客户JDE号',
            dataIndex: 'customerJdeCode',
            key: 'customerJdeCode',
            width: 100,
        }, {
            title: '客户全名',
            dataIndex: 'customerCompanyName',
            key: 'customerCompanyName',
            width: 160,
        }, {
            title: 'BA工号',
            dataIndex: 'baEmployeeCode',
            key: 'baEmployeeCode',
            width: 100,
        }, {
            title: 'BA姓名',
            dataIndex: 'baUserCompellation',
            key: 'baUserCompellation',
            width: 100,
        }, {
            title: '申办方',
            dataIndex: 'investigationSponsor',
            key: 'investigationSponsor',
            width: 160,
        },
        //  {
        //     title: '合同新增时间',
        //     dataIndex: 'createTime',
        //     key: 'createTime',
        //     width: 100,
        //     render: text => format('date', text)
        // }, 
        {
            title: '合同开始时间',
            dataIndex: 'startTime',
            key: 'startTime',
            width: 100,
        }, {
            title: '合同结束时间',
            dataIndex: 'endTime',
            key: 'endTime',
            width: 100,
        }, {
            title: '合同中是否明标合同金额',
            dataIndex: 'investigationJdeContractIsSpecifiesAmount',
            key: 'investigationJdeContractIsSpecifiesAmount',
            width: 100,
            render: text => Default[text],
        }, {
            title: '币种',
            dataIndex: 'currency',
            key: 'currency',
            width: 100,
        }, {
            title: '汇率',
            dataIndex: 'exchangeRate',
            key: 'exchangeRate',
            width: 80,
        }, {
            title: '合同额含税/原币',
            dataIndex: 'initialContractAmount',
            key: 'initialContractAmount',
            width: 120,
            render: text => format('money', text),
        }, {
            title: '合同额含税/人民币(元)',
            dataIndex: 'jdeContractAmount',
            key: 'jdeContractAmount',
            width: 120,
            render: text => format('money', text),
        }, {
            title: '实报实销(不含税)/原币',
            dataIndex: 'initialActualExpenseFee',
            key: 'initialActualExpenseFee',
            width: 120,
            render: text => format('money', text),
        }, {
            title: '实报实销税费/原币',
            dataIndex: 'initialActualFee',
            key: 'initialActualFee',
            width: 120,
            render: text => format('money', text),
        }, {
            title: '合同额税费/原币',
            dataIndex: 'initialContractFee',
            key: 'initialContractFee',
            width: 120,
            render: text => format('money', text),
        }, {
            title: '实报实销(不含税)/人民币(元)',
            dataIndex: 'jdeActualExpenseFee',
            key: 'jdeActualExpenseFee',
            width: 120,
            render: text => format('money', text),
        }, {
            title: '实报实销税费/人民币',
            dataIndex: 'jdeActualFee',
            key: 'jdeActualFee',
            width: 120,
            render: text => format('money', text),
        }, {
            title: '合同额税费/人民币（元）',
            dataIndex: 'jdeContractFee',
            key: 'jdeContractFee',
            width: 120,
            render: text => format('money', text),
        }, {
            title: '合同税率',
            dataIndex: 'rate',
            key: 'rate',
            width: 100,
            render: (text) => format('unit', text, '%'),
        }, 
        {
            title: '累计收入不含税/原币',
            dataIndex: 'initialTotalIncomeNoTax',
            key: 'initialTotalIncomeNoTax',
            width: 120,
            render: text => format('money', text),
        }, {
            title: '累计收入不含税/人民币',
            dataIndex: 'cnyTotalIncomeNoTax',
            key: 'cnyTotalIncomeNoTax',
            width: 120,
            render: text => format('money', text),
        }, {
            title: '累计上月收入不含税/原币',
            dataIndex: 'initialTotalLastMonthIncomeNoTax',
            key: 'initialTotalLastMonthIncomeNoTax',
            width: 120,
            render: text => format('money', text),
        }, {
            title: '累计上月收入不含税/人民币',
            dataIndex: 'cnyTotalLastMonthIncomeNoTax',
            key: 'cnyTotalLastMonthIncomeNoTax',
            width: 120,
            render: text => format('money', text),
        }, 
        {
            title: 'FTE单价(含税)(元)',
            dataIndex: 'fteUnitPrice',
            key: 'fteUnitPrice',
            width: 120,
            render: text => format('money', text),
        }, {
            title: '合同请款完成情况',
            dataIndex: 'contractRemittanceCompletedInfo',
            key: 'contractRemittanceCompletedInfo',
            width: 100,
            render: text => RequestStatus[text],
        }, {
            title: "操作",
            dataIndex: 'operation',
            key: 'operation',
            width: 80,
            fixed: 'right',
            render: (text, record) => {
                const operationCorrespondRoles = new Map([
                    ['edit', {
                        name: '修改',
                        display: true,
                        editable: true,
                        event: () => this.props.update(record, 'edit'),
                        roles: ['FIN'],
                    }],
                    ['delete', {
                        name: '删除',
                        display: true,
                        editable: true,
                        event: () => this.delete(record),
                        roles: ['FIN'],
                    }]
                ]);
                return genOperationAuth(operationCorrespondRoles, curRole);
            },
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    render() {
        const { data, loading, pagination } = this.state;
        return (
            <TableC
                data={data}
                scrollY={460}
                loading={loading}
                columns={this.getColumns()}
                rowKey="investigationJdeContractHistoryId"
                className="historyRecord"
                pagination={pagination}
                onChange={this.handleTableChange}
            />
        );
    }
}

export default History;


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/History.js